<template>
  <div>
    <commBanner :obj="obj"></commBanner>
    <titleHead :headTitle="headTitle"></titleHead>
    <div class="w80 mb-30">
      <el-container>
        <el-aside width="330px">
          <sidebar></sidebar>
        </el-aside>
        <el-main>
          <companySide
            v-if="type"
            :isButton="isButton"
            @release="gorelease()"
          ></companySide>
          <headSide v-else @release="gorelease()"></headSide>
          <!--新增需求-->
          <div class="mt-30">
            <contTitle :obj="obj" :contTitle="contTitle" @onBacker="Backer()"></contTitle>
            <el-form
              class="info_form"
              ref="form"
              :rules="rules"
              :model="form"
              label-width="100px"
            >
              <div class="fdc mt-30">
                <div style="width: 50%">
                  <el-form-item label="需求标题 :" prop="title" style="width: 90%">
                    <el-input
                      type="textarea"
                      :maxlength="50"
                      placeholder="最多50字"
                      v-model="form.title"
                    ></el-input>
                  </el-form-item>
                </div>
                <div style="width: 50%">
                  <el-form-item label="需求分类 :" prop="type0">
                    <el-select
                      v-model="form.type0"
                      placeholder="需求分类"
                      clearable
                      @change="onChang0()"
                      :disabled="isEdit"
                    >
                      <el-option
                        v-for="item in categoryGroup"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="需求类别 :" prop="type" v-if="isGongYing">
                    <el-cascader
                      :options="categoryList"
                      :props="optionProps"
                      v-model="form.type"
                      :show-all-levels="false"
                      style="width: 100%"
                      @change="onChang()"
                    >
                    </el-cascader>
                  </el-form-item>
                  <el-form-item label="需求类别 :" prop="type" v-else>
                    <el-select
                      v-model="form.type"
                      placeholder="需求分类"
                      clearable
                    >
                      <el-option
                        v-for="item in categorys"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item label="开始时间 :" prop="beginDate">
                    <el-date-picker
                      type="date"
                      placeholder="选择日期"
                      :picker-options="pickerOptionsStart"
                      value-format="yyyy-MM-dd"
                      v-model="form.beginDate"
                      @change="startTimeStatus"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                  <el-form-item label="结束时间 :" prop="endDate">
                    <el-date-picker
                      type="date"
                      placeholder="选择日期"
                      v-model="form.endDate"
                      value-format="yyyy-MM-dd"
                      :picker-options="pickerOptionsEnd"
                      @change="endTimeStatus"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-form-item>
                </div>
              </div>
              <div class="tel mt-20">
                <el-form-item label="详情介绍 :" prop="content">
                  <tinymceEditor
                    class="mt-15"
                    :myValue="form.content"
                    @input="parantEvent"
                    v-model="form.content"
                    ref="editor"
                  ></tinymceEditor>
                </el-form-item>
                <!-- <p class="text_center"></p> -->
                <el-form-item prop="agree" class="fuck">
                  <el-checkbox v-model="form.agree" name="checked"></el-checkbox>
                  <div style="margin-left: 5px">
                    我已阅读并同意《
                    <span class="agree" @click="settChange()">供需信息发布声明</span>
                    》
                  </div>
                </el-form-item>
                <button class="mt-30" @click.prevent="onSubmit('form')">
                  {{ buttonText }}
                </button>
              </div>
            </el-form>
          </div>
        </el-main>
      </el-container>

      <!--发布声明弹框-->
      <div class="sett_dialog" v-show="dialogTableVisible">
        <div class="sett_cox"></div>
        <div class="sett_dialog_box">
          <div class="sett_matter">
            <p class="sett_title">供需信息发布声明</p>
            <p class="sett_jitr">
              <span v-if="!isImg">{{ time }}s</span>
              <img
                v-show="isImg"
                src="../../assets/images/sign.png"
                @click.prevent="onText()"
              />
            </p>
          </div>
          <div class="sett_desc" v-html="issueStatement.des"></div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import {addDemand, addDemandRecruit, agreement, eitdDemand, eitdDemandRecruit} from "@/api/coment";
  import sidebar from "../../common/sidebar";
  import headSide from "../../common/headSide";
  import companySide from "../../common/companySide";
  import commBanner from "../../common/commBanner";
  import titleHead from "../../common/titleHead";
  import contTitle from "../../common/contTitle";
  import tinymceEditor from "../../common/tinymceEditor.vue";
  import { dateFormat } from '@/utils';

  export default {
  components: {
    sidebar,
    headSide,
    companySide,
    commBanner,
    titleHead,
    contTitle,
    tinymceEditor,
  },
  data() {
    return {
      isEdit:false,
      isGongYing:true,
      categoryGroup:[{
        value: '1',
        label: '供应需求'
      },{
        value: '2',
        label: '人力需求'
      },],
      categorys:[{
        value: 2,
        label: '招聘需求'
      }, {
        value: 3,
        label: '求职需求'
      }],
      issueStatement: "",
      isImg: false,
      time: 10,
      dialogTableVisible: false,
      contTitle: "添加需求",
      buttonText: "添加需求",
      headTitle: "我的需求",
      obj: {
        title: "我的需求",
        isShow: false,
        backer: false,
        roleType: "",
        personalType: 9,
        //  content:'公司主营产品及服务包括:金属氧化物避雷器带电检测仪、数字式钳形伏安相位表、大型地网接地电阻测量仪、多通道波形记录仪、PT感应耐压试验电源、高压高稳定电源...',
        //  bannerUrl:require('@/assets/images/banner.jpg')
      },
      form: {
        title: "",
        type0: "",
        beginDate: "", //开始时间
        endDate: "", //结束时间
        content: "", //内容
        type: "",
        userId: "",
        agree: "",
      },
      rules: {
        title: [{ required: true, message: "请输入需求标题", trigger: "blur" }],
        type0: [{ required: true, message: "请选择需求分类", trigger: "change" }],
        type: [{ required: true, message: "请选择需求类别", trigger: "change" }],
        beginDate: [{ required: true, message: "请选择开始时间", trigger: "change" }],
        endDate: [{ required: true, message: "请选择结束时间", trigger: "change" }],
        content: [{ required: true, message: "请输入需求内容", trigger: "blur" }],
        agree: [
          {
            required: true,
            message: "请接受智污邦发布声明",
            trigger: "change",
          },
        ],
      },
      categoryList: [], //分类列表
      optionProps: {
        value: "id",
        label: "name",
        children: "children",
      },
      type: false,
      isButton: false,
      // 限制结束日期大于开始日期
      pickerOptionsStart: {
        disabledDate: (time) => {
          if (this.form.endDate) {
            return time.getTime() > new Date(this.form.endDate).getTime();
          }
        },
      },
      pickerOptionsEnd: {
        disabledDate: (time) => {
          if (this.form.beginDate) {
            return time.getTime() < new Date(this.form.beginDate).getTime();
          }
        },
      },
    };
  },
  created() {
    this.getAgreement();
    let type = this.$store.state.user.userInfo.type;
    this.obj.roleType = type;
    if(type == 3){
        this.type = true;
        this.headTitle = "企业需求";
        this.obj.title = "企业需求";
    }
    let id = this.$route.query.id;
    let type0 = this.$route.query.type0;
    if(id){
      this.getEitdDemand(id,type0);
    }
  },
  computed:{
    Industry(){
       return this.$store.getters.industry;
    }
  },
  watch:{
    Industry:{
      handler(val){
        if(val[0] != undefined){
          this.categoryList = val[0].children;
        }
      },
      immediate:true
    }
  },
  methods: {
    //发布需求
    onSubmit(formName) {
      this.form.userId = this.$store.state.user.userInfo.userId;
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.form.type0=='1'){
            //用户每次发布需求或者更改需求满足条件：开始时间不能小于当前时间。2022/04/08
            var nowTime = new Date(dateFormat(new Date(),'YYYY-MM-dd'));
            var demendbeginDateTime = new Date(dateFormat(new Date(this.form.beginDate),'YYYY-MM-dd'));
            if (nowTime.getTime() > demendbeginDateTime.getTime()){
              this.$message({
                message: "需求开始时间小于当前时间！",
                tyoe: "error"
              })
            }else{
              if (this.form.id !== undefined) {
              addDemand(this.form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message({
                      message: "提交成功！",
                      type: "success",
                      duration: 1000,
                      onClose: () => {
                        this.$router.push("/demand");
                      },
                    });
                  }
                  this.showList = true;
                  this.show = false;
                })
                .catch((err) => {});
            } else {
              addDemand(this.form)
                .then((res) => {
                  if (res.code == 0) {
                    this.$message({
                      message: "发布成功！审核通过后获取积分",
                      type: "success",
                      duration: 1000,
                      onClose: () => {
                        this.$router.push("/demand");
                      },
                    });
                  }
                  this.showList = true;
                  this.show = false;
                })
                .catch((err) => {});
            }
            }
          }else{
            addDemandRecruit(this.form)
              .then((res) => {
                if (res.code == 0) {
                  this.$message({
                    message: "添加成功！",
                    type: "success",
                    duration: 1000,
                    onClose: () => {
                      this.$router.push("/demand");
                    },
                  });
                }
                this.showList = true;
                this.show = false;
              })
              .catch((err) => {});
          }

        }
      });
    },
    getAgreement() {
      agreement()
        .then((res) => {
          this.issueStatement = res.page.filter((item) => item.name == "供需信息发布声明")[0];
        })
        .catch((err) => {});
    },
    settChange() {
      this.dialogTableVisible = true;
      this.timer = setInterval(() => {
        this.time--;
        if (this.time == 0) {
          clearInterval(this.timer);
          this.isImg = true;
        }
      }, 1000);
    },
    onText() {
      this.dialogTableVisible = false;
    },
    //选中
    onChang0() {
      this.form.type=''
      if(this.form.type0!='1'){
        this.isGongYing=false
      }else{
        this.isGongYing=true
      }
    },
    onChang() {
      this.form.type = this.form.type[this.form.type.length - 1];
    },
    startTimeStatus(value) {
      this.form.beginDate = value;
    },
    endTimeStatus(value) {
      this.form.endDate = value;
    },
    parantEvent(data) {
      this.form.content = data;
    },
    //返回列表
    Backer() {
      this.$router.push("/demand");
    },
    getEitdDemand(id,type0){
      this.isEdit=true;
      let params ={demandId:id};
      if(type0=='1'){
        this.isGongYing=true
        eitdDemand(params).then(res=>{
          if(res.code ==0){
            this.form = res.data;
            this.form.type0='1'
            this.obj.backer = true;
          }
        }).catch(err=>{});
      }else{
        this.isGongYing=false
        eitdDemandRecruit(params).then(res=>{
          if(res.code ==0){
            this.form = res.data;
            this.form.type0='2'
            this.obj.backer = true;
          }
        }).catch(err=>{});
      }

      },
  },
};
</script>
<style scoped="scoped">
.pl-15 {
  padding-left: 15px;
}
.tel {
  text-align: left;
}
.dn {
  display: none;
}
.mt-15 {
  margin-top: 15px;
}
.mt-20 {
  margin-top: 20px;
}
.info_form >>> .el-input--suffix .el-input__inner {
  height: 50px;
}
.needs_list {
  width: 100%;
  height: 103px;
  margin-top: 20px;
  border: 1px solid #dedede;
  transition: all 0.5s;
}
.needs_list:hover {
  box-shadow: 0 0 20px #ddd;
}
.list_head {
  margin: 0px 20px;
  padding-top: 15px;
}
.list_title {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  width: 80%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-align: left;
}
.list_date {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.list_heads {
  margin: 0px 20px;
  padding-top: 14px;
}
.list_heads p span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.list_heads p span.detail {
  color: #333333;
}

.needs_list_tetx:hover {
  cursor: pointer;
}

.el-form-item {
  text-align: left;
}
.info_form >>> .el-textarea__inner {
  /* width:px; */
  height: 169px;
}
.info_form >>> .el-checkbox__input.is-checked + .el-checkbox__label {
  color: #99cf2a !important;
}

.tel button {
  width: 129px;
  height: 35px;
  background: #3bbb35;
  border-radius: 3px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
  text-align: center;
  line-height: 1px;
}
.text_center {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

/**协议弹框 */
.sett_dialog {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  overflow: hidden;
  margin: 0;
  z-index: 999;
}
.sett_dialog_box {
  width: 500px;
  height: 600px;
  position: absolute;
  top: 50%;
  left: 50%;
  border-radius: 3px;
  transform: translate(-50%, -50%);
  background: #ffffff;
  overflow: auto;
}
.sett_cox {
  position: fixed;
  left: 0;
  /* opacity: 0.3; */
  width: 100%;
  height: 100%;
  top: 0;
  background-color: rgba(0, 0, 0, 0.8);
  /* z-index:2003 !important; */
}
.sett_matter {
  position: relative;
  height: 50px;
}
.sett_title {
  font-size: 22px;
  color: #666666;
  height: 30px;
  line-height: 48px;
  text-align: center;
}
.sett_jitr {
  position: absolute;
  right: 20px;
  top: 10px;
}
.sett_jitr img {
  width: 20px;
  height: 20px;
}
/**协议弹框 */
.sett_dialog >>> .el-dialog {
  width: 500px;
  height: 600px;
}
.sett_dialog >>> .el-dialog__header {
  text-align: center;
}
.sett_dialog >>> .el-dialog__title {
  font-size: 24px;
}
.sett_desc {
  padding: 30px;
  font-size: 14px;
  line-height: 24px;
  color: #666666;
}
/deep/ .fuck .el-form-item__content {
  display: flex;
  align-items: center;
}
.agree {
  cursor: pointer;
  color: #69cc1e;
}
.agree:hover {
  text-decoration: underline;
}
</style>




// WEBPACK FOOTER //
// src/view/coment/demandAdd.vue